/**
 * Default export.
 *
 * @param Vue
 */
export default (Vue) => {
  Vue.component('f-select-company', () => import('./select-company'))
  Vue.component('f-select-company-address', () => import('./select-company-address'))
  Vue.component('f-select-company-professional', () => import('./select-company-professional'))
  Vue.component('f-select-professional-specialities', () => import('./select-professional-specialities'))
  Vue.component('f-select-company-staff', () => import('./select-company-staff'))
}



// WEBPACK FOOTER //
// ./src/components/form/fields/company/index.js